import type { PanelComponentSpec } from '@src/types/LayoutConfig';
import { PANEL_COMPONENT_GROUPS } from '../Trading/groups';
import { MarketCapEstimatedPanel } from './MarketCapEstimatedPanel';

export const SIGNALS_PANEL_COMPONENTS: PanelComponentSpec[] = [
  {
    group: PANEL_COMPONENT_GROUPS['signals'],
    section: 'trading',
    type: 'marketCapEstimated',
    label: 'Market Cap (Est.)',
    icon: undefined,
    canBeAdded: true,
    renderer: MarketCapEstimatedPanel,
  },
];
